goog.provide("shadow.js.shim.module$src$svg$files_folders$file_spreadsheet_svg$default");
shadow.js.shim.module$src$svg$files_folders$file_spreadsheet_svg$default = shadow.js.shim.module$src$svg$files_folders$file_spreadsheet_svg.default;
